module.exports = __webpack_public_path__ + "media/app/assets/races/zandalari_troll_female-a4df203c4cdafa54890fa2a45dfcf61d.png";